const S3_BASE_URL =
  'https://eon-public-b2b628cc-1d96-4fda-8dae-c3b1ad3ea03b.s3.amazonaws.com';

export const getMongoAtlasRestoreProjectCode = (
  projectId: string,
  eonAccountId: string,
  restoreAccountId: string,
  connectMethod: 'terraform' | 'bash'
) => {
  const restoreNodeRoleArn = restoreAccountId
    ? `arn:aws:iam::${restoreAccountId}:role/EonRestoreNodeRole`
    : '';
  const terraformCode = `\
# Configure the MongoDB Atlas provider authentication.
# See: https://registry.terraform.io/providers/mongodb/mongodbatlas/latest/docs/guides/provider-configuration#authentication-methods

provider "mongodbatlas" {
    public_key  = "<your-atlas-public-key>"
    private_key = "<your-atlas-private-key>"
}

module "mongo_atlas_restore" {
    source                 = "${S3_BASE_URL}/mongo-atlas-eon-setup.zip"
    account_type           = "restore"
    project_id             = "${projectId || '<project-id>'}"
    eon_account_id         = "${eonAccountId || '<eon-account-id>'}"
    restore_node_role_arn = "${restoreNodeRoleArn || '<restore-node-role-arn>'}"
}

# After applying, retrieve the Eon API key:
#   terraform output eon_public_key
#   terraform output -raw eon_private_key`;

  const bashCode = `\
curl -fsSL ${S3_BASE_URL}/mongo-atlas-eon-setup.sh \\
  -o mongo-atlas-eon-setup.sh && \\
chmod +x mongo-atlas-eon-setup.sh && \\
./mongo-atlas-eon-setup.sh \\
  --account-type Restore \\
  --project-id ${projectId || '<project-id>'} \\
  --eon-account-id ${eonAccountId || '<eon-account-id>'} \\
  --restore-node-role-arn ${restoreNodeRoleArn || '<restore-node-role-arn>'} \\
  --atlas-public-key <your-atlas-public-key> \\
  --atlas-private-key <your-atlas-private-key>

# The script will output the Eon API key.
# Enter it in the Eon UI to complete the connection.`;

  return connectMethod === 'terraform' ? terraformCode : bashCode;
};
